// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared Stitch list chrome for the Clinic section. */
.cidx-screen {
  box-sizing: border-box;
  padding: 24px;
  min-width: 0;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cidx-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding-bottom: 20px;
  border-bottom: 1px solid #F1F5F9;
}

.cidx-heading__left {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.cidx-heading__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  flex-wrap: wrap;
}

.cidx-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.cidx-title-row h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: #0F172A;
}

.cidx-count {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 9999px;
  border: 1px solid #E0F2FE;
  font-size: 12px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  background: #E0F2FE;
  color: #0284C7;
}

.cidx-count.is-slate {
  border-color: #E2E8F0;
  background: #F1F5F9;
  color: #475569;
}

.cidx-subtitle {
  margin: 0;
  font-size: 12px;
  line-height: 16px;
  color: #64748B;
}

.cidx-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.cidx-btn--secondary {
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #334155;
}

.cidx-btn--secondary:hover:not(:disabled) {
  background: #F8FAFC;
}

.cidx-btn--secondary .anticon {
  color: #64748B;
  font-size: 14px;
}

.cidx-btn--primary {
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
}

.cidx-btn--primary:hover:not(:disabled) {
  background: #0284C7;
  border-color: #0284C7;
}

.cidx-btn--primary .anticon {
  font-size: 14px;
}

.cidx-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.cidx-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.cidx-toolbar__filters {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1 280px;
  min-width: 0;
  flex-wrap: wrap;
}

.cidx-search {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1 240px;
  min-width: 0;
  max-width: 480px;
  height: 38px;
  padding: 0 12px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  transition: border-color 0.12s ease, box-shadow 0.12s ease;
}

.cidx-search:focus-within {
  border-color: #0EA5E9;
  box-shadow: 0 0 0 1px #0EA5E9;
}

.cidx-search__icon {
  flex-shrink: 0;
  color: #94A3B8;
  font-size: 16px;
  margin-inline-end: 8px;
}

.cidx-search__input.ant-input-affix-wrapper,
.cidx-search__input.ant-input {
  flex: 1 1 auto;
  min-width: 0;
  height: 34px !important;
  padding: 0 !important;
  border: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
  font-size: 12px;
}

.cidx-search__input.ant-input-affix-wrapper .ant-input {
  font-size: 12px;
}

.cidx-select {
  min-width: 160px;
}

.cidx-select .ant-select-selector {
  height: 38px !important;
  border-radius: 8px !important;
  border-color: #E2E8F0 !important;
  align-items: center !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  background: #ffffff !important;
  box-shadow: none !important;
}

.cidx-select.ant-select-focused .ant-select-selector {
  border-color: #0EA5E9 !important;
  box-shadow: 0 0 0 1px #0EA5E9 !important;
}

.cidx-facility {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 38px;
  padding: 0 12px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #F8FAFC;
  font-size: 12px;
  color: #0F172A;
  white-space: nowrap;
}

.cidx-facility__label {
  color: #64748B;
}

.cidx-table-card {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  overflow: hidden;
  min-width: 0;
  max-width: 100%;
}

.cidx-list {
  height: auto;
  min-width: 0;
}

.cidx-table-scroll {
  width: 100%;
  overflow-x: auto;
  min-width: 0;
}

.cidx-table {
  --cidx-cols: 1fr;
  display: grid;
  grid-template-columns: var(--cidx-cols);
  width: 100%;
  min-width: var(--cidx-min, 720px);
  font-size: 12px;
  background: #ffffff;
}

.cidx-table__head,
.cidx-table__row {
  display: grid;
  grid-template-columns: subgrid;
  grid-column: 1 / -1;
  align-items: stretch;
  margin: 0;
  padding: 0;
  border-radius: 0;
  box-sizing: border-box;
}

.cidx-table__head {
  border-bottom: 1px solid #E2E8F0;
}

.cidx-table__head .cidx-cell {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 8px 16px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748B;
  white-space: nowrap;
  background: #F8FAFC;
}

.cidx-table__row {
  border-bottom: 1px solid #F1F5F9;
}

.cidx-table__row.is-interactive {
  cursor: pointer;
}

.cidx-table__row:last-child {
  border-bottom: 0;
}

.cidx-table__row .cidx-cell {
  display: flex;
  align-items: center;
  min-height: 52px;
  padding: 10px 16px;
  color: #334155;
  min-width: 0;
  background: #ffffff;
  transition: background 0.12s ease;
}

.cidx-table__row:hover .cidx-cell {
  background: #F8FAFC;
}

.cidx-table--compact .cidx-table__head .cidx-cell {
  min-height: 28px;
  padding: 4px 12px;
}

.cidx-table--compact .cidx-table__row .cidx-cell {
  min-height: 32px;
  padding: 2px 12px;
}

.cidx-table--compact .cidx-chip {
  height: 18px;
  padding: 0 6px;
  font-size: 10px;
}

.cidx-table--compact .cidx-row-btn {
  height: 24px;
  padding: 0 8px;
  font-size: 11px;
}

.cidx-html-table {
  width: 100%;
  border-collapse: collapse;
  background: #ffffff;
  font-size: 13px;
}

.cidx-html-table th,
.cidx-html-table td {
  padding: 8px 16px;
  text-align: start;
  vertical-align: middle;
  border-bottom: 1px solid #F1F5F9;
  white-space: nowrap;
}

.cidx-html-table th {
  background: #F8FAFC;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748B;
  border-bottom-color: #E2E8F0;
}

.cidx-html-table th.is-id,
.cidx-html-table td.is-id {
  width: 72px;
}

.cidx-html-table th.is-status,
.cidx-html-table td.is-status {
  width: 140px;
}

.cidx-html-table th.is-end,
.cidx-html-table td.is-end {
  text-align: end;
}

.cidx-html-table tr.is-interactive {
  cursor: pointer;
}

.cidx-html-table tbody tr:last-child td {
  border-bottom: 0;
}

.cidx-html-table tbody tr:hover td {
  background: #F8FAFC;
}

.cidx-html-table--relaxed td {
  padding-top: 14px;
  padding-bottom: 14px;
}

.cidx-cell.is-end {
  justify-content: flex-end;
  text-align: end;
}

[dir='rtl'] .cidx-cell.is-end {
  justify-content: flex-start;
}

.cidx-cell.is-center {
  justify-content: center;
}

.cidx-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  color: #64748B;
  line-height: 1.25;
}

.cidx-mono.is-id {
  color: #0284C7;
  font-weight: 600;
}

.cidx-mono.is-strong {
  color: #0F172A;
  font-weight: 600;
}

.cidx-code {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 6px;
  border: 1px solid #E2E8F0;
  background: #F1F5F9;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 500;
  color: #334155;
}

.cidx-name {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.25;
  color: #0F172A;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cidx-muted {
  color: #64748B;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cidx-stack {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.cidx-stack__sub {
  font-size: 11px;
  font-weight: 400;
  line-height: 1.3;
  color: #64748B;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cidx-who {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.cidx-avatar {
  width: 28px;
  height: 28px;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 700;
  background: #E0F2FE;
  color: #0284C7;
  border: 1px solid #BAE6FD;
}

.cidx-avatar.is-indigo {
  background: #EEF2FF;
  color: #4338CA;
  border-color: #C7D2FE;
}

.cidx-avatar.is-amber {
  background: #FFFBEB;
  color: #B45309;
  border-color: #FDE68A;
}

.cidx-avatar.is-slate {
  background: #F1F5F9;
  color: #475569;
  border-color: #E2E8F0;
}

.cidx-tile {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: #E0F2FE;
  color: #0284C7;
  border: 1px solid #BAE6FD;
  font-size: 14px;
}

.cidx-tile.is-muted {
  background: #F1F5F9;
  color: #64748B;
  border-color: #E2E8F0;
}

.cidx-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 22px;
  padding: 0 8px;
  border-radius: 9999px;
  border: 1px solid transparent;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.cidx-chip__dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: currentColor;
  flex-shrink: 0;
}

.cidx-chip.is-sky {
  background: #F0F9FF;
  color: #0369A1;
  border-color: #BAE6FD;
}

.cidx-chip.is-indigo {
  background: #EEF2FF;
  color: #4338CA;
  border-color: #C7D2FE;
}

.cidx-chip.is-amber {
  background: #FFFBEB;
  color: #B45309;
  border-color: #FDE68A;
}

.cidx-chip.is-violet {
  background: #F5F3FF;
  color: #6D28D9;
  border-color: #DDD6FE;
}

.cidx-chip.is-active {
  background: #ECFDF5;
  color: #059669;
  border-color: #A7F3D0;
}

.cidx-chip.is-inactive {
  background: #F1F5F9;
  color: #64748B;
  border-color: #E2E8F0;
}

.cidx-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.cidx-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 9999px;
  background: #E0F2FE;
  color: #0284C7;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.cidx-row-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 28px;
  padding: 0 10px;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 1px 1px rgba(15, 23, 42, 0.04);
}

.cidx-row-link:hover {
  border-color: #0EA5E9;
  color: #0EA5E9;
  background: #F8FAFC;
}

[dir='rtl'] .cidx-row-link .anticon {
  transform: scaleX(-1);
}

.cidx-row-actions {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  flex-wrap: wrap;
}

.cidx-row-btn {
  box-sizing: border-box;
  height: 28px;
  padding: 0 10px;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
}

.cidx-row-btn:hover:not(:disabled) {
  border-color: #BAE6FD;
  color: #0284C7;
  background: #F0F9FF;
}

.cidx-row-btn.is-accent {
  border-color: #BAE6FD;
  background: #F0F9FF;
  color: #0284C7;
}

.cidx-row-btn.is-accent:hover:not(:disabled) {
  background: #0EA5E9;
  border-color: #0EA5E9;
  color: #ffffff;
}

.cidx-row-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.cidx-price.ant-input-number {
  width: 100%;
  border-radius: 8px;
  border-color: #E2E8F0;
}

.cidx-price.ant-input-number-focused {
  border-color: #0EA5E9;
  box-shadow: 0 0 0 1px #0EA5E9;
}

.cidx-empty {
  padding: 40px 24px;
  text-align: center;
  color: #94A3B8;
}

.cidx-empty p {
  margin: 8px 0 0;
  font-size: 14px;
  font-weight: 500;
}

.cidx-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 16px;
  border-top: 1px solid #E2E8F0;
  background: #ffffff;
  font-size: 12px;
}

.cidx-pager__meta {
  color: #64748B;
  font-variant-numeric: tabular-nums;
  font-weight: 500;
}

.cidx-pager__controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cidx-pager__btn {
  box-sizing: border-box;
  height: 32px;
  padding: 0 12px;
  border-radius: 6px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
}

.cidx-pager__btn:hover:not(:disabled) {
  background: #F8FAFC;
}

.cidx-pager__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.cidx-pager__page {
  font-variant-numeric: tabular-nums;
  color: #475569;
  font-size: 12px;
  font-weight: 500;
  min-width: 72px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/ClinicalIndex/style.css"],"names":[],"mappings":"AAAA,sDAAsD;AACtD;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,2BAA2B;EAC3B,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uCAAuC;EACvC,WAAW;EACX,iCAAiC;EACjC,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB","sourcesContent":["/* Shared Stitch list chrome for the Clinic section. */\n.cidx-screen {\n  box-sizing: border-box;\n  padding: 24px;\n  min-width: 0;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.cidx-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.cidx-heading__left {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.cidx-heading__actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n}\n\n.cidx-title-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.cidx-title-row h1 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n  color: #0F172A;\n}\n\n.cidx-count {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 10px;\n  border-radius: 9999px;\n  border: 1px solid #E0F2FE;\n  font-size: 12px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  background: #E0F2FE;\n  color: #0284C7;\n}\n\n.cidx-count.is-slate {\n  border-color: #E2E8F0;\n  background: #F1F5F9;\n  color: #475569;\n}\n\n.cidx-subtitle {\n  margin: 0;\n  font-size: 12px;\n  line-height: 16px;\n  color: #64748B;\n}\n\n.cidx-btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 36px;\n  padding: 0 14px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.cidx-btn--secondary {\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #334155;\n}\n\n.cidx-btn--secondary:hover:not(:disabled) {\n  background: #F8FAFC;\n}\n\n.cidx-btn--secondary .anticon {\n  color: #64748B;\n  font-size: 14px;\n}\n\n.cidx-btn--primary {\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n}\n\n.cidx-btn--primary:hover:not(:disabled) {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.cidx-btn--primary .anticon {\n  font-size: 14px;\n}\n\n.cidx-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.cidx-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.cidx-toolbar__filters {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1 1 280px;\n  min-width: 0;\n  flex-wrap: wrap;\n}\n\n.cidx-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 1 1 240px;\n  min-width: 0;\n  max-width: 480px;\n  height: 38px;\n  padding: 0 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  transition: border-color 0.12s ease, box-shadow 0.12s ease;\n}\n\n.cidx-search:focus-within {\n  border-color: #0EA5E9;\n  box-shadow: 0 0 0 1px #0EA5E9;\n}\n\n.cidx-search__icon {\n  flex-shrink: 0;\n  color: #94A3B8;\n  font-size: 16px;\n  margin-inline-end: 8px;\n}\n\n.cidx-search__input.ant-input-affix-wrapper,\n.cidx-search__input.ant-input {\n  flex: 1 1 auto;\n  min-width: 0;\n  height: 34px !important;\n  padding: 0 !important;\n  border: 0 !important;\n  box-shadow: none !important;\n  background: transparent !important;\n  font-size: 12px;\n}\n\n.cidx-search__input.ant-input-affix-wrapper .ant-input {\n  font-size: 12px;\n}\n\n.cidx-select {\n  min-width: 160px;\n}\n\n.cidx-select .ant-select-selector {\n  height: 38px !important;\n  border-radius: 8px !important;\n  border-color: #E2E8F0 !important;\n  align-items: center !important;\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  background: #ffffff !important;\n  box-shadow: none !important;\n}\n\n.cidx-select.ant-select-focused .ant-select-selector {\n  border-color: #0EA5E9 !important;\n  box-shadow: 0 0 0 1px #0EA5E9 !important;\n}\n\n.cidx-facility {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 38px;\n  padding: 0 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #F8FAFC;\n  font-size: 12px;\n  color: #0F172A;\n  white-space: nowrap;\n}\n\n.cidx-facility__label {\n  color: #64748B;\n}\n\n.cidx-table-card {\n  box-sizing: border-box;\n  background: #ffffff;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  overflow: hidden;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.cidx-list {\n  height: auto;\n  min-width: 0;\n}\n\n.cidx-table-scroll {\n  width: 100%;\n  overflow-x: auto;\n  min-width: 0;\n}\n\n.cidx-table {\n  --cidx-cols: 1fr;\n  display: grid;\n  grid-template-columns: var(--cidx-cols);\n  width: 100%;\n  min-width: var(--cidx-min, 720px);\n  font-size: 12px;\n  background: #ffffff;\n}\n\n.cidx-table__head,\n.cidx-table__row {\n  display: grid;\n  grid-template-columns: subgrid;\n  grid-column: 1 / -1;\n  align-items: stretch;\n  margin: 0;\n  padding: 0;\n  border-radius: 0;\n  box-sizing: border-box;\n}\n\n.cidx-table__head {\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.cidx-table__head .cidx-cell {\n  display: flex;\n  align-items: center;\n  min-height: 40px;\n  padding: 8px 16px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748B;\n  white-space: nowrap;\n  background: #F8FAFC;\n}\n\n.cidx-table__row {\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.cidx-table__row.is-interactive {\n  cursor: pointer;\n}\n\n.cidx-table__row:last-child {\n  border-bottom: 0;\n}\n\n.cidx-table__row .cidx-cell {\n  display: flex;\n  align-items: center;\n  min-height: 52px;\n  padding: 10px 16px;\n  color: #334155;\n  min-width: 0;\n  background: #ffffff;\n  transition: background 0.12s ease;\n}\n\n.cidx-table__row:hover .cidx-cell {\n  background: #F8FAFC;\n}\n\n.cidx-table--compact .cidx-table__head .cidx-cell {\n  min-height: 28px;\n  padding: 4px 12px;\n}\n\n.cidx-table--compact .cidx-table__row .cidx-cell {\n  min-height: 32px;\n  padding: 2px 12px;\n}\n\n.cidx-table--compact .cidx-chip {\n  height: 18px;\n  padding: 0 6px;\n  font-size: 10px;\n}\n\n.cidx-table--compact .cidx-row-btn {\n  height: 24px;\n  padding: 0 8px;\n  font-size: 11px;\n}\n\n.cidx-html-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: #ffffff;\n  font-size: 13px;\n}\n\n.cidx-html-table th,\n.cidx-html-table td {\n  padding: 8px 16px;\n  text-align: start;\n  vertical-align: middle;\n  border-bottom: 1px solid #F1F5F9;\n  white-space: nowrap;\n}\n\n.cidx-html-table th {\n  background: #F8FAFC;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748B;\n  border-bottom-color: #E2E8F0;\n}\n\n.cidx-html-table th.is-id,\n.cidx-html-table td.is-id {\n  width: 72px;\n}\n\n.cidx-html-table th.is-status,\n.cidx-html-table td.is-status {\n  width: 140px;\n}\n\n.cidx-html-table th.is-end,\n.cidx-html-table td.is-end {\n  text-align: end;\n}\n\n.cidx-html-table tr.is-interactive {\n  cursor: pointer;\n}\n\n.cidx-html-table tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.cidx-html-table tbody tr:hover td {\n  background: #F8FAFC;\n}\n\n.cidx-html-table--relaxed td {\n  padding-top: 14px;\n  padding-bottom: 14px;\n}\n\n.cidx-cell.is-end {\n  justify-content: flex-end;\n  text-align: end;\n}\n\n[dir='rtl'] .cidx-cell.is-end {\n  justify-content: flex-start;\n}\n\n.cidx-cell.is-center {\n  justify-content: center;\n}\n\n.cidx-mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 12px;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n  color: #64748B;\n  line-height: 1.25;\n}\n\n.cidx-mono.is-id {\n  color: #0284C7;\n  font-weight: 600;\n}\n\n.cidx-mono.is-strong {\n  color: #0F172A;\n  font-weight: 600;\n}\n\n.cidx-code {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 6px;\n  border: 1px solid #E2E8F0;\n  background: #F1F5F9;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 12px;\n  font-weight: 500;\n  color: #334155;\n}\n\n.cidx-name {\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.25;\n  color: #0F172A;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cidx-muted {\n  color: #64748B;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cidx-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.cidx-stack__sub {\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 1.3;\n  color: #64748B;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cidx-who {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.cidx-avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 9999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 11px;\n  font-weight: 700;\n  background: #E0F2FE;\n  color: #0284C7;\n  border: 1px solid #BAE6FD;\n}\n\n.cidx-avatar.is-indigo {\n  background: #EEF2FF;\n  color: #4338CA;\n  border-color: #C7D2FE;\n}\n\n.cidx-avatar.is-amber {\n  background: #FFFBEB;\n  color: #B45309;\n  border-color: #FDE68A;\n}\n\n.cidx-avatar.is-slate {\n  background: #F1F5F9;\n  color: #475569;\n  border-color: #E2E8F0;\n}\n\n.cidx-tile {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  background: #E0F2FE;\n  color: #0284C7;\n  border: 1px solid #BAE6FD;\n  font-size: 14px;\n}\n\n.cidx-tile.is-muted {\n  background: #F1F5F9;\n  color: #64748B;\n  border-color: #E2E8F0;\n}\n\n.cidx-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 9999px;\n  border: 1px solid transparent;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.cidx-chip__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: currentColor;\n  flex-shrink: 0;\n}\n\n.cidx-chip.is-sky {\n  background: #F0F9FF;\n  color: #0369A1;\n  border-color: #BAE6FD;\n}\n\n.cidx-chip.is-indigo {\n  background: #EEF2FF;\n  color: #4338CA;\n  border-color: #C7D2FE;\n}\n\n.cidx-chip.is-amber {\n  background: #FFFBEB;\n  color: #B45309;\n  border-color: #FDE68A;\n}\n\n.cidx-chip.is-violet {\n  background: #F5F3FF;\n  color: #6D28D9;\n  border-color: #DDD6FE;\n}\n\n.cidx-chip.is-active {\n  background: #ECFDF5;\n  color: #059669;\n  border-color: #A7F3D0;\n}\n\n.cidx-chip.is-inactive {\n  background: #F1F5F9;\n  color: #64748B;\n  border-color: #E2E8F0;\n}\n\n.cidx-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.cidx-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 10px;\n  border-radius: 9999px;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.cidx-row-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 28px;\n  padding: 0 10px;\n  border-radius: 8px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  box-shadow: 0 1px 1px rgba(15, 23, 42, 0.04);\n}\n\n.cidx-row-link:hover {\n  border-color: #0EA5E9;\n  color: #0EA5E9;\n  background: #F8FAFC;\n}\n\n[dir='rtl'] .cidx-row-link .anticon {\n  transform: scaleX(-1);\n}\n\n.cidx-row-actions {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.cidx-row-btn {\n  box-sizing: border-box;\n  height: 28px;\n  padding: 0 10px;\n  border-radius: 8px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.cidx-row-btn:hover:not(:disabled) {\n  border-color: #BAE6FD;\n  color: #0284C7;\n  background: #F0F9FF;\n}\n\n.cidx-row-btn.is-accent {\n  border-color: #BAE6FD;\n  background: #F0F9FF;\n  color: #0284C7;\n}\n\n.cidx-row-btn.is-accent:hover:not(:disabled) {\n  background: #0EA5E9;\n  border-color: #0EA5E9;\n  color: #ffffff;\n}\n\n.cidx-row-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.cidx-price.ant-input-number {\n  width: 100%;\n  border-radius: 8px;\n  border-color: #E2E8F0;\n}\n\n.cidx-price.ant-input-number-focused {\n  border-color: #0EA5E9;\n  box-shadow: 0 0 0 1px #0EA5E9;\n}\n\n.cidx-empty {\n  padding: 40px 24px;\n  text-align: center;\n  color: #94A3B8;\n}\n\n.cidx-empty p {\n  margin: 8px 0 0;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.cidx-pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 12px 16px;\n  border-top: 1px solid #E2E8F0;\n  background: #ffffff;\n  font-size: 12px;\n}\n\n.cidx-pager__meta {\n  color: #64748B;\n  font-variant-numeric: tabular-nums;\n  font-weight: 500;\n}\n\n.cidx-pager__controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.cidx-pager__btn {\n  box-sizing: border-box;\n  height: 32px;\n  padding: 0 12px;\n  border-radius: 6px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.cidx-pager__btn:hover:not(:disabled) {\n  background: #F8FAFC;\n}\n\n.cidx-pager__btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.cidx-pager__page {\n  font-variant-numeric: tabular-nums;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 500;\n  min-width: 72px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
